module.exports = __webpack_public_path__ + "img/that-picture-2.2890319e.png";